import React, {Component} from 'react'

import Screen from '../ui/Screen'

import TreeList from "./../ui/TreeList"
import ExpandState from "./../ui/ExpandState"
import ErrorMessageDialog from "./../ui/ErrorMessageDialog"
import SelectFolderDialog from "./../ui/SelectFolderDialog"

import ControlPanel from "./TemplatesScreen/ControlPanel"

import CreateFolderDialog from "./TemplatesScreen/CreateFolderDialog"
import CreateTemplateDialog from "./TemplatesScreen/CreateTemplateDialog"
import DeleteFolderDialog from "./TemplatesScreen/DeleteFolderDialog"
import DeleteTemplateDialog from "./TemplatesScreen/DeleteTemplateDialog"
import EditFolderDialog from "./TemplatesScreen/EditFolderDialog"
import EditTemplateDialog from "./TemplatesScreen/EditTemplateDialog"

import EditTemplateItemsScreen from "./TemplatesScreen/EditTemplateItemsScreen"

import TemplateIcon from '@material-ui/icons/ListAlt'

import Cookie from "../Cookie"
import {config} from "../config"

import Wait from "../ui/Wait.js"

import api from "../api.js"

/**
 * <TemplatesScreen />
 */

class TemplatesScreen extends Component {

	constructor(props) {
		super(props)

		this.state = {
			templates: [],
			selected: undefined,
			dialog: undefined,
			screen: undefined,
		}

		this.handleCreateFolder = this.handleCreateFolder.bind(this)
		this.handleCreateTemplate = this.handleCreateTemplate.bind(this)
		this.handleEditFolder = this.handleEditFolder.bind(this)
		this.handleEditTemplate = this.handleEditTemplate.bind(this)
		this.handleDeleteFolder = this.handleDeleteFolder.bind(this)
		this.handleDeleteTemplate = this.handleDeleteTemplate.bind(this)
		this.handleEditTemplateItems = this.handleEditTemplateItems.bind(this)
		this.handleError = this.handleError.bind(this)
		this.handleClick = this.handleClick.bind(this)
		this.handleMoveToFolder = this.handleMoveToFolder.bind(this)
	}

	expandState = new ExpandState()

	async getTemplates() {

		let normalize = (items, parent) => {
			for(let item of items) {
				item.parent = parent
				if (item.type.toString == "0") {
					item.items = normalize(item.items, item)
				}
			}
			return items
		}

		let list = await api.templates.list()
		return normalize(list["templates"], undefined)
	}

	findNewSelected(selected, templates) {
		if (selected) {
			for(let template of templates) {
				if (template.id === selected.id) {
					return template
				}
				if (template.type.toString() === "0") {
					let t = this.findNewSelected(selected, template.items)
					if (t) {
						return t
					}
				}
			}
		}
	}

	update = async () => {
		let templates = await this.getTemplates()
		this.expandState.updateTree(templates)
		this.setState({
			templates: templates,
			selected: this.expandSelectedParents(this.findNewSelected(this.state.selected, templates)),
		})
	}

	componentDidMount() {
		this.getTemplates().then(templates => {
			this.templates = templates
			this.setState({
				templates: templates,
				selected: undefined,
			})
		}, this.handleError)
	}

	async createTemplateItem(item) {
		let response = await api.templates.create(item.name, item.type, item.folder_id)
		return response["template"]
	}

	updateTemplateItem(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/template/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось обновить данные шаблона или папки")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify(item))
		})
	}

	deleteTemplateItem(item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("DELETE", config.restApiHost + `/show/template/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Не удалось удалить шаблон или папку")
					}
				}
			}
			xhr.send()
		})
	}

	handleError(errorMessage) {
		this.setState({
			dialog: <ErrorMessageDialog
				message = {errorMessage}
				onClose = {() => {
					this.update().then(() => {
						this.setState({
							dialog: undefined
						})
					}, this.handleError)
				}}
			/>
		})
	}

	handleCreateFolder() {
		this.setState({
			dialog: <CreateFolderDialog
				onCreateFolder = {folder => {
					let folderId = 0
					if (this.state.selected) {
						if (this.state.selected.type.toString() === "0") {
							folderId = this.state.selected.id
						} else {
							folderId = this.state.selected.folder_id
						}
					}
					this.createTemplateItem({
						name: folder.name,
						type: 0,
						folder_id: folderId,
						code: "",
					}).then(item => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleCreateTemplate() {
		this.setState({
			dialog: <CreateTemplateDialog
				onCreateTemplate = {async (template, templates) => {
					let folderId = 0
					if (this.state.selected) {
						if (this.state.selected.type.toString() === "0") {
							folderId = this.state.selected.id
						} else {
							folderId = this.state.selected.folder_id
						}
					}
					this.setState({ dialog: <Wait message = "Создаём шаблон шоу" /> })
					await this.createTemplateItem({
						name: template.name,
						type: 1,
						folder_id: folderId,
					})
						.then(async (template) => {
							for (let t of templates) {
								for (let attachment of t.items) {
									await api.templates.attachments.create(template.id, attachment.item_id, attachment.amount, attachment.repeat)
								}
							}
						})
						.then(this.update)
						.then(() => this.setState({ dialog: undefined }))
						.catch(this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleEditFolder(folder) {
		this.setState({
			dialog: <EditFolderDialog
				folder = {folder}
				onUpdateFolder = {folder => {
					this.updateTemplateItem(folder).then(() => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	/**
	 * Запуск диалога редактирования шаблона (переименовать шаблон, не вложения).
	 * 
	 * @param {Number} template - шаблон.
	 */

	async handleEditTemplate(template) {
		this.setState({
			dialog: <EditTemplateDialog
				template = {template}
				onUpdateTemplate = {template => {
					this.updateTemplateItem(template).then(() => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleDeleteFolder(folder) {
		this.setState({
			dialog: <DeleteFolderDialog
				folder = {folder}
				onDeleteFolder = {folder => {
					this.deleteTemplateItem(folder).then(() => {
						this.update().then(() => {
							this.setState({
								dialog: undefined
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						selected: undefined,
						dialog: undefined,
					})
				}}
			/>
		})
	}

	handleDeleteTemplate(template) {
		this.setState({
			dialog: <DeleteTemplateDialog
				template = {template}
				onDeleteTemplate = {template => {
					this.deleteTemplateItem(template).then(() => {
						this.update().then(() => {
							this.setState({
								selected: undefined,
								dialog: undefined,
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	/**
	 * Редактировать шаблон (вложения).
	 * 
	 * @param {*} template - шаблон.
	 */

	async handleEditTemplateItems(template) {
		let response = await api.templates.get_template_items(template.id)
		template.items = response["items"]
		this.setState({
			screen: <EditTemplateItemsScreen
				template = {template}
				onClose = {() => {
					this.update().then(templates => {
						this.setState({screen: undefined})
					}, this.handleError)
				}}
			/>
		})
	}

	handleClick(template) {
		if (this.state.selected ? (this.state.selected.id === template.id) : false) {
			if (template.type.toString() === "0") {
				template.expand = !template.expand
				this.expandState.set(template.id, template.expand)
				this.forceUpdate()
			} else {
				this.handleEditTemplateItems(template)
			}
		} else {
			this.setState({
				selected: this.expandSelectedParents(template)
			})
		}
	}

	expandSelectedParents(item) {
		let itm = item
		if (itm) {
			while(itm.parent) {
				itm.expand = true
				this.expandState.set(itm.id, itm.expand)
				itm = itm.parent
			}
		}
		return item
	}

	/**
	 * Проверяет, можно ли скопировать итем или папку в заданную папку
	 * Нельзя, если template = папка и заданная папака находится
	 * внутри копируемой папки или является собой (нельзя копировать в себя)
	 */

	itemReadyToMove(template, folder) {
		return new Promise((resolve, reject) => {

			let scan = f => {
				if (!folder) { // любую папку можно коипировать в корень
					return true
				}
				if (f.id === folder.id) {
					return false
				}
				for (let itm of f.items) {
					if (itm.type.toString() === "0") {
						if (!scan(itm)) {
							return false
						}
					}
				}
				return true
			}

			if (template.type.toString() === "0") { // move folder
				if (scan(template)) {
					resolve(template, folder)
				} else {
					reject("Нельзя копировать папку в себя, или во вложенные папки")
				}
			} else { // move template
				resolve(template, folder)
			}

		})
	}

	moveToFolder(template, folder) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/template/${template.id}/folder/${folder.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve()
					} else {
						reject("Ну изменить родительскую папку")
					}
				}
			}
			xhr.send()
		})
	}

	handleMoveToFolder(template) {
		this.getTemplates().then(templates => {
			this.setState({
				dialog: <SelectFolderDialog
					items = {templates}
					disableFolder = {template}
					onSelectFolder = {folder => {
						this.itemReadyToMove(template, folder).then(result => {
							this.moveToFolder(template, folder).then(() => {
								this.update().then(() => {
									this.setState({
										selected: this.expandSelectedParents(template),
										dialog: undefined,
									})
								}, this.handleError)
							}, this.handleError)
						}, this.handleError)
					}}
					onCancel = {() => {
						this.setState({
							dialog: undefined
						})
					}}
				/>
			})
		})
	}

	render() {

		if (this.state.screen) {
			return this.state.screen
		}

		return <Screen
			onClick = {e => {
				if (!this.state.dialog) {
					e.stopPropagation()
					this.setState({
						selected: undefined
					})
				}
			}}
		>

			{this.state.dialog}

			<ControlPanel
				selected = {this.state.selected}
				onCreateFolderClick = {this.handleCreateFolder}
				onCreateTemplateClick = {this.handleCreateTemplate}
				onEditTemplateItemsClick = {this.handleEditTemplateItems}
				onMoveToFolderClick = {this.handleMoveToFolder}
				onEditItemClick = {item => {
					if (item.type.toString() === "0") {
						this.handleEditFolder(item)
					}
					if (item.type.toString() === "1") {
						this.handleEditTemplate(item)
					}
				}}
				onDeleteItemClick = {item => {
					if (item.type.toString() === "0") {
						this.handleDeleteFolder(item)
					}
					if (item.type.toString() === "1") {
						this.handleDeleteTemplate(item)
					}
				}}

			/>

			<TreeList
				items = {this.state.templates}
				selected = {this.state.selected}
				itemIcon = {<TemplateIcon />}
				onClickItem = {this.handleClick}
			/>

		</Screen>

	}

}

export default TemplatesScreen
